<template>
    <div>
        <FunctionSection></FunctionSection>
        <!-- <RecentPaperSection style="margin-top:15px;"></RecentPaperSection> -->
        <!-- <RecentNewsSection style="margin-top: 18px;"></RecentNewsSection> -->
    </div>
</template>

<script>
import request from '@/utils/request'
import FunctionSection from "./FunctionSection";
import RecentPaperSection from "./RecentPaperSection";
import RecentNewsSection from "./RecentNewsSection";

export default {
  name: "DefaultLeftBar",
    components: {RecentNewsSection, RecentPaperSection, FunctionSection},
    created() {
    let e = this.$route
  },
  data() {
    return {
      research: [],
      news: [],
    }
  },
  methods: {
  }
}
</script>

<style scoped>
/* .tool { width: 268px; background: #fff; border: #e8e8e8 1px solid; overflow: hidden; }
.tool h3 { line-height: 54px; border-bottom: #e8e8e8 1px solid; padding:0 20px ;font-size: 16px; font-weight: bold; color: #555;}
.tool h3 a { float: right; font-size: 14px; font-weight: normal; color: #000}
.tool_ul { padding-left: 20px;overflow: hidden;}
.mt15 .tool_ul { padding-right: 20px;}
.tool_ul li { width: 124px; line-height: 40px; height: 40px; float: left;}
.tool_ul li a { display: inline-block}
.tool_ul li a img { float: left; margin: 10px 8px 0 0; width: 20px; height: 20px;}
.mt15 { margin-top: 15px;} */
</style>



// WEBPACK FOOTER //
// src/components/DefaultLeftBar.vue